<script>

import BannerItemComp from './BannerItem';
import { esellerMethods, esellerComputed, layoutMethods, erpUserRolesMethods  } from "@/state/helpers";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';
import ImageUpload from '@/components/ImageUpload';
import { getModuleAccess } from '@/router/helper.js'

/**
 * ESeller Banner component
 */
export default {
  page: {
    title: "E-Seller Banner"
  },
  data() {
    return {
      isInvalid: false,
      file: null,
      title: "E-Seller Banner",
      items: [],
      folder: 'esupplies-banners',
      pageOptions: [12, 24, 36, 48, 60, 72, 84, 96, 108, 120],
      bannerImage: {
        filename: null,
        type: null,
        base64: null
      },
      pagination: {
        rows: 12,
        page: 1,
        search: null,
        searchField: null,
        sort: null,
        orderDesc: true,
        bannerType: null,
        bannerStatus: null
      },
      searchOptions: [
        {text: 'Search All', value:null},
        {text: 'Banner Name', value:'name'},
        {text: 'Banner Description', value:'description'},
      ],
      sortOptions: [
        {text: 'All', value:null},
        {text: 'Banner Name', value:'name'},
        {text: 'Banner Description', value:'description'},
      ],
      sortOrderOptions: [
        {text: 'ASC', value:false},
        {text: 'DESC', value:true}
      ],
      bannerTypeOptions: [
        {text: 'All', value:null},
        {text: 'Product', value:'product'},
        {text: 'Brand', value:'brand'},
      ],
      bannerStatusOptions: [
        {text: 'All', value:null},
        {text: 'Active', value:'1'},
        {text: 'Inactive', value:'0'},
      ],
      editModal: false,
      createModal: false,
      brandSelection: null,
      productSelection: null,

      bannerItem: {
        bannerId: null,
        bannerName: "",
        bannerActiveNow: 0,
        bannerType: 'brand',
        bannerDestinationId: null,
        bannerDescription: ""
      },

      formExitChecker: {
        bannerId: null,
        bannerName: "",
        bannerActiveNow: 0,
        bannerType: 'brand',
        bannerDestinationId: null,
        bannerDescription: ""
      },
      esuppliesBannerModule: {
        access: {
          create: true,
          update: true,
          delete: true
        }
      }
    };
  },
  components: { 
    'banner-item' : BannerItemComp,
    Multiselect,
    ImageUpload
  },
  computed: {
    ...esellerComputed,
    selectedAdElement: {
      get(){
        var selected = null;
        this.targetOptions.forEach(brand => {
          if(brand.value == this.bannerItem.bannerDestinationId){
            selected = brand;
          }
        });
        return selected;
      },
      set(obj){
        if(obj){
          this.bannerItem.bannerDestinationId = obj.value;
        }else {
          this.bannerItem.bannerDestinationId = null;
        }
        
      }
    },
    targetOptions: {
      get(){
        if(this.bannerItem.bannerType == "brand"){
          return this.SellerBrandOptions;
        } else {
          return this.SellerProductOptions;
        }
      }
    },
    SellerBrandOptions: {
      get(){
        return this.brands.map(brand => {
          return { 'text': brand.brandName, 'value': brand.brandId }
        });
      }
    },
    SellerProductOptions: {
      get(){
        return this.products.map(product => {
          return { 'text': product.productName, 'value': product.productId }
        });
      }
    }
  },
  watch: {
    'bannerItem.bannerActiveNow': function(newVal) {
      this.bannerItem.bannerActiveNow = newVal | 0;
      console.log(newVal);
    }
  },
  methods: {
    ...layoutMethods,
    ...esellerMethods,
    ...erpUserRolesMethods,
      initBrandProductSelections()
      {
        this.bannerItem.bannerDestinationId  = null;
      },
      onTouch () {
        this.isTouched = true
      },
      refresh(){
        this.pagination.page = 1;
        // this.pagination.search    = null
        // this.pagination.searchField   = null
        // this.pagination.sort    = null
        // this.pagination.orderDesc   = true
        // this.pagination.bannerType    = {text: 'All', value:null}
        // this.pagination.bannerStatus    = {text: 'All', value:null}
        this.populateBanners();
      },
      openCreateModal(){
        this.clearBanner();
        this.clearLogo();
        this.createModal = true;
      },
      populateBanners(){
        this.listSellerBanners(this.pagination);

      },
      createBanner(){
        var bannerObj = { ...this.bannerItem };

        console.log(bannerObj);
        // Validation
        if(!bannerObj.bannerDestinationId){
          this.isInvalid = true;
          return;
        }

        console.log(bannerObj);
        delete bannerObj.bannerId;
              
        if(this.bannerImage.base64){
          var bannerImage = { ...this.bannerImage };
          bannerImage.folder = this.folder;

          this.uploadLogo(bannerImage)
            .then((imageKey) => {
              bannerObj = { 
                ...bannerObj,
                bannerImageSrc: imageKey
              }
              
              this.create(bannerObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!",`${err}`, "error");
            });
        } else {
          this.create(bannerObj);
        }
      },
      editBanner(banner){
        if (!this.esuppliesBannerModule.access.read && !this.esuppliesBannerModule.access.update) {
          Swal.fire(
          "Access Restricted", 
          "Looks like your access is limited. Please contact your administrator.", 
          "warning");
        } else {
          this.editModal = true;
          this.bannerItem = {
              bannerId: banner.bannerId,
              bannerName: banner.bannerName,
              bannerActiveNow: banner.bannerActiveNow,
              bannerType: banner.destinations.type,
              bannerDestinationId: banner.destinations.id,
              bannerDescription: banner.bannerDescription,
              bannerPreviewImage: banner.bannerImageSrc,
              oldBannerName: banner.bannerName
          }
          this.formExitChecker = {
              bannerId: banner.bannerId,
              bannerName: banner.bannerName,
              bannerActiveNow: banner.bannerActiveNow,
              bannerType: banner.destinations.type,
              bannerDestinationId: banner.destinations.id,
              bannerDescription: banner.bannerDescription,
              bannerPreviewImage: banner.bannerImageSrc,
              oldBannerName: banner.bannerName
          }
        }
      },
      saveBanner(){
        var bannerObj = { ...this.bannerItem };

        if(this.bannerImage.base64){
          var bannerImage = { ...this.bannerImage };
          bannerImage.folder = this.folder;

          this.uploadLogo(bannerImage)
            .then((imageKey) => {
              bannerObj = { 
                ...bannerObj,
                bannerImageSrc: imageKey
              }
              
              this.update(bannerObj);
            })
            .catch((err) => {
              Swal.fire("Upload Failed!",`${err}`, "error");
            });
        } else {
          
          this.update(bannerObj);
        }
      },
      deleteBanner(banner){
        if (!this.esuppliesBannerModule.access.delete) {
          Swal.fire(
            "Access Restricted", 
            "You are not allowed to delete a banner.", 
            "warning");
        } else {
          Swal.fire({
            title: "Are you sure?",
            text: `Do you really want to delete ${banner.bannerName}? This process cannot be undone.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes",
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.isConfirmed) {
              this.deleteSellerBanner(banner.bannerId)
                .then(() => {
                  Swal.fire("Delete Successful!", `${banner.bannerName} has been deleted.`, "success");
                  this.populateBanners();
                })
                .catch((error) => {
                  Swal.fire("Delete Failed!", `An Error Occured: ${error}`, "danger");
                });
            } else {
              return;
            }
          });
        }
        
      },
      create(banner){
        this.createSellerBanner(banner)
          .then(() => {
            this.createModal = false;
            Swal.fire("Create Successful!", `${banner.bannerName} has been created.`, "success");
            this.populateBanners();
            this.clearLogo();
          })
          .catch(() => {
            this.createModal = false;
            Swal.fire("Create Failed!",`${banner.bannerName} was not created.`, "danger");
            this.clearLogo();
          });
      },
      update(banner){
        let oldBannerName = banner.oldBannerName.length < 1 ? `${banner.bannerId} (no name)` : banner.oldBannerName;
        this.updateSellerBanner(banner)
          .then(() => {
            this.editModal = false;
            Swal.fire("Update Successful!", `${oldBannerName} has been updated.`, "success");
            this.populateBanners();
            this.clearLogo();
          })
          .catch(() => {
            this.editModal = false;
            Swal.fire("Update Failed!",`${oldBannerName} was not updated.`, "danger");
            this.clearLogo();
          });
      },
      clearLogo(){
        this.bannerImage = {
          filename: null,
          type: null,
          base64: null
        }
      },
      clearBanner()
      {
        
        this.bannerItem = {
          bannerId: null,
          bannerName: "",
          bannerActiveNow: 0,
          bannerType: 'brand',
          bannerDestinationId: null,
          bannerDescription: ""
        }
        this.formExitChecker = {
          bannerId: null,
          bannerName: "",
          bannerActiveNow: 0,
          bannerType: 'brand',
          bannerDestinationId: null,
          bannerDescription: ""
        }
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      search(){
        this.pagination.page = 1;
        this.populateBanners();
      },
      leaveform(modal = 'add'){
          if(JSON.stringify(this.bannerItem) == JSON.stringify(this.formExitChecker)){
              if(modal == 'add'){
                  this.createModal = false;
              }else if(modal == 'edit'){
                  this.editModal = false;
              }
              this.clearBanner();
              return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  if(modal == 'add'){
                      this.createModal = false;
                  }else if(modal == 'edit'){
                      this.editModal = false;
                  }
                  this.clearBanner();
              }else{
                  return;
              }
          })
      },
      onDisplayChange(){
        console.log(this.esellerBannerTotalRows,this.pagination.rows,this.banners.length,(this.banners.length < this.esellerBannerTotalRows && this.banners.length != this.pagination.rows));
        if(
          (this.banners.length < this.esellerBannerTotalRows && this.banners.length != this.pagination.rows) || // condition for incrementing display per page
          (this.banners.length == this.esellerBannerTotalRows && this.pagination.rows < this.banners.length) // condition for decreasing display per page
          ){
          this.search()
        }
      }
    },
    async mounted(){
      this.listSellerBrands({ rows: 99999 });
      this.listSellerProducts({ rows: 99999 });
      this.populateBanners();
      this.changeTitle({title: 'E-Seller Banners'});
      this.changeBreadCrumb({
         breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'E-Seller', to: { name: 'ESeller'} },
          { text: 'Banner', to: { name: 'ESeller Banner'} }
        ]
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eSupplies', 'Banners')
      .then((access) => this.esuppliesBannerModule.access = access);
      
    },
    
  };
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="my-2">
                  <h5 class="card-title text-dark">
                    <span class="fw-normal ms-lg-2">{{esellerBannerTotalRows}}</span> Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <div class="col-md-8 col-sm-8">
                <div class="d-flex justify-content-lg-end mb-lg-3">
                  <template>
                    <div class="me-2">
                      <b-button v-if="esuppliesBannerModule.access.create"
                        @click="$router.push({ path: 'banner/add' })"
                        variant="primary"
                        ><i class="uil uil-plus me-1"></i> Create Banner</b-button
                      >

                      <b-modal
                        id="modalAddBanner"
                        title="Add E-Supply Banner"
                        size="md"
                        centered
                        hide-footer
                        hide-header-close
                        v-model="createModal"
                      >
                        <ValidationObserver v-slot="{ handleSubmit, reset }">
                          <b-form class="px-4 py-3" @submit.prevent="handleSubmit(createBanner)" @@reset.prevent="reset">
                            <div class="row">
                              <div class="col-md-12 mb-3">
                                <label class="form-label small fw-bold"
                                  >Banner Name<span style="color: red">*</span></label
                                >
                                <validation-provider name="Banner name" rules="required" v-slot="validationContext">
                                  <b-form-input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Banner Name"
                                    v-model="bannerItem.bannerName"
                                    :state="getValidationState(validationContext)"
                                  />
                                  <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                  </b-form-invalid-feedback>
                                </validation-provider>
                              </div>
                              <div class="cold-md-12 mb-3">
                                <label
                                  for="formFile"
                                  class="form-label small fw-bold"
                                  >Banner Description</label
                                >
                                <b-form-textarea
                                  id="textarea"
                                  placeholder="Enter Banner description..."
                                  rows="3"
                                  max-rows="6"
                                  v-model="bannerItem.bannerDescription"
                                ></b-form-textarea>
                              </div>
                              <div class="cold-md-12 mb-3">
                                <label class="form-label small fw-bold">Banner Type</label>
                                <div class="form-check">
                                  <input class="form-check-input" value="brand"  type="radio" :reset-on-options-change='true' v-model="bannerItem.bannerType"  v-on:change="initBrandProductSelections" name="flexRadioDefault" id="flexRadioDefault1"  checked="checked">
                                  <label class="form-check-label" for="flexRadioDefault1">
                                    Brand
                                  </label>
                                </div>
                                <div class="form-check">
                                  <input class="form-check-input" value="product" v-model="bannerItem.bannerType"  v-on:change="initBrandProductSelections"  type="radio" name="flexRadioDefault" id="flexRadioDefault2">
                                    <label class="form-check-label" for="flexRadioDefault2">
                                      Product
                                    </label>
                                </div>
                              </div>
                              <div class="col-md-12 mb-3">
                                <div :class="{ 'invalid': isInvalid }">
                                  <label class="typo__label form-label small fw-bold">{{bannerItem.bannerType == 'brand' ? 'Brands' : 'Products'}}<span style="color: red">*</span>
                                  </label>
                                  <validation-provider name="target" rules="required" v-slot="{ errors, ariaMsg }">
                                    <multiselect 
                                      v-model="selectedAdElement" 
                                      :options="targetOptions"
                                      track-by="value"
                                      label="text"
                                      name="target"
                                      select-label="Click to select"
                                      deselect-label="Click to remove"
                                      :placeholder="bannerItem.bannerType == 'brand' ? 'Select Brand Category' : 'Select Product Item'"
                                      :allow-empty="true"
                                      :preselect-first="false"
                                      :class="{
                                        'invalid': errors[0]
                                      }"
                                    ></multiselect>
                                    <b-form-invalid-feedback v-bind="ariaMsg">
                                      {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                  </validation-provider>
                                </div>

                                
                              </div>
                              <div class="cold-md-12 mb-3">
                                <image-upload v-model="bannerImage" label="Banner Image" :isRequired="true" />
                              </div>
                              <div class="cold-md-12 mb-3">
                                <div class="form-check form-switch">
                                  <input class="form-check-input" v-model="bannerItem.bannerActiveNow" type="checkbox" id="flexSwitchCheckDefault">
                                  <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                                </div>
                              </div>
                            </div>
                            <div class="text-end mt-3">             
                              <b-button
                                variant="light"
                                class="w-sm"
                                @click="leaveform()"
                                >Close</b-button
                              >
                              <b-button
                                variant="primary"
                                class="w-sm ms-2"
                                type="submit"
                                >Save</b-button
                              >
                            </div>
                          </b-form>
                        </ValidationObserver>
                      </b-modal>
                    </div>
                  </template>

                  <a class="btn btn-secondary"
                    @click="refresh()"
                    ><feather
                      type="refresh-ccw"
                      size="16"
                      class="icon nav-icon"
                    ></feather
                    >&nbsp;&nbsp; Refresh</a
                  >
                </div>
              </div>
              <!-- end col -->

              <div class="col-12 ta-right">

                <div class="row my-lg-2 my-3">

                    <div class="col-lg-4 mt-lg-0 mt-3">
                      <b-form-group
                        description="Search keyword"
                      >
                        <div class="d-flex">
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                          v-model="pagination.searchField"
                          :options="searchOptions"
                        ></b-form-select>
                        <b-form-input v-on:keyup.enter="search" v-model="pagination.search" class="rounded-0"></b-form-input>
                        </div>
                      </b-form-group>
                    </div>

                    <div class="col-lg-2 mt-lg-0 mt-2">
                      <b-form-group
                        description="Filter by type"
                      > 
                        <multiselect
                          v-model="pagination.bannerType"
                          :options="bannerTypeOptions"
                          track-by="value"
                          label="text"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Banner Type"
                          :allow-empty="false"
                          :preselect-first="true"
                        ></multiselect>
                      </b-form-group>
                    </div>

                    <div class="col-lg-2 mt-lg-0 mt-2">
                      <b-form-group
                        description="Filter by status"
                      >
                        <multiselect
                          v-model="pagination.bannerStatus"
                          :options="bannerStatusOptions"
                          track-by="value"
                          label="text"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Status"
                          :allow-empty="false"
                          :preselect-first="true"
                        ></multiselect>
                      </b-form-group>
                    </div>

                    <div class="col mt-lg-0 mt-2">
                      <b-form-group
                        description="Order by"
                      >
                        <div class="d-flex">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-fit"
                            v-model="pagination.sort"
                            :options="sortOptions"
                          ></b-form-select>
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-fit"
                            v-model="pagination.orderDesc"
                            :options="sortOrderOptions"
                          ></b-form-select>
                        </div>
                      </b-form-group>
                    </div>

                    <div class="col ps-1 mt-lg-0 mt-2">
                      <b-form-group
                        label=""
                      >
                        <b-button variant="primary" type="button" @click="search" class="px-2 float-start">
                          <i class='bx bx-search bx-fw'></i>
                        </b-button>
                      </b-form-group>
                    </div>
                </div>
                
                <!-- <div class="d-flex flex-wrap mt-3 mb-3">
                    <div class="me-3">
                      <b-form-group
                        description="Search keyword"
                      >
                        <div class="d-flex">
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                          v-model="pagination.searchField"
                          :options="searchOptions"
                        ></b-form-select>
                        <b-form-input v-on:keyup.enter="search" v-model="pagination.search" class="rounded-0"></b-form-input>
                        </div>
                      </b-form-group>
                    </div>

                    <div class="me-3 w-200px">
                      <b-form-group
                        description="Filter by type"
                      > 
                        <multiselect
                          v-model="pagination.bannerType"
                          :options="bannerTypeOptions"
                          track-by="value"
                          label="text"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Banner Type"
                          :allow-empty="false"
                          :preselect-first="true"
                        ></multiselect>
                      </b-form-group>
                    </div>

                    <div class="me-3 w-300px">
                      <b-form-group
                        description="Filter by status"
                      >
                        <multiselect
                          v-model="pagination.bannerStatus"
                          :options="bannerStatusOptions"
                          track-by="value"
                          label="text"
                          select-label="Click to select"
                          deselect-label="Click to remove"
                          placeholder="Select Status"
                          :allow-empty="false"
                          :preselect-first="true"
                        ></multiselect>
                      </b-form-group>
                    </div>

                    <div class="me-3 w-350px">
                      <b-form-group
                        description="Order by"
                      >
                        <div class="d-flex">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-fit"
                            v-model="pagination.sort"
                            :options="sortOptions"
                          ></b-form-select>
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-fit"
                            v-model="pagination.orderDesc"
                            :options="sortOrderOptions"
                          ></b-form-select>
                        </div>
                      </b-form-group>
                    </div>
                    
                    <div>
                      <b-form-group
                        label=""
                      >
                        <b-button variant="primary" type="button" @click="search" class="px-2">
                          <i class='bx bx-search bx-fw'></i>
                        </b-button>
                      </b-form-group>
                    </div>
                </div> -->
              </div>
            </div>
            <!-- end row -->

            <!-- grid list business category -->

            <template>
              <div class="row">
                <banner-item
                  v-for="(banner, index) in banners" 
                  v-bind:key="index"
                  v-bind:banner="banner"
                  @edit="$router.push({ path: `banner/edit/${banner.bannerId}` })"
                  @delete="deleteBanner(banner)"
                  />
              </div>
              <!-- end row -->
            </template>
            <div class="row g-0 text-center" v-if="esellerBannerTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start mt-3">
              <!-- end col -->
              <div class="col-sm-12" v-if="esellerBannerTotalRows != 0 && esellerBannerTotalRows > 12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="pagination.rows"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                       v-if="esellerBannerTotalRows != 0 && esellerBannerTotalRows > 12 && esellerBannerTotalRows > pagination.rows"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                          v-model="pagination.page"
                          @input="populateBanners"
                          :total-rows="esellerBannerTotalRows"
                          :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- all modal -->
    <!-- edit modal -->
    <b-modal
      id="modalEditBusinessCategory"
      title="Edit Banner"
      size="md"
      centered
      hide-footer
      hide-header-close
      v-model="editModal"
      >
        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <b-form class="px-4 py-3" @submit.prevent="handleSubmit(saveBanner)" @@reset.prevent="reset">
            <div class="row">
              <label v-if="!esuppliesBannerModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a banner.</label>    
              <div class="col-md-12 mb-3">
                <label class="form-label small fw-bold"
                  >Banner Name<span style="color: red">*</span></label
                >
                <validation-provider name="Banner name" rules="required" v-slot="validationContext">
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Enter Banner Name"
                    v-model="bannerItem.bannerName"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <div class="cold-md-12 mb-3">
                <label
                  for="formFile"
                  class="form-label small fw-bold"
                  >Banner Description</label
                >
                <b-form-textarea
                  id="textarea"
                  placeholder="Enter Banner description..."
                  rows="3"
                  max-rows="6"
                  v-model="bannerItem.bannerDescription"
                ></b-form-textarea>
              </div>
              <div class="cold-md-12 mb-3">
                <label class="form-label small fw-bold">Banner Type</label>
                <div class="form-check">
                  <input class="form-check-input" value="brand"  type="radio" :reset-on-options-change='true' v-model="bannerItem.bannerType"  v-on:change="initBrandProductSelections" name="flexRadioDefault" id="flexRadioDefault1"  checked="checked">
                  <label class="form-check-label" for="flexRadioDefault1">
                    Brand
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" value="product" v-model="bannerItem.bannerType"  v-on:change="initBrandProductSelections"  type="radio" name="flexRadioDefault" id="flexRadioDefault2">
                    <label class="form-check-label" for="flexRadioDefault2">
                      Product
                    </label>
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <div :class="{ 'invalid': isInvalid }">
                  <label class="typo__label form-label small fw-bold">{{bannerItem.bannerType == 'brand' ? 'Brands' : 'Products'}}<span style="color: red">*</span>
                  </label>
                  <validation-provider name="target" rules="required" v-slot="{ errors, ariaMsg }">
                    <multiselect 
                      v-model="selectedAdElement" 
                      :options="targetOptions"
                      track-by="value"
                      label="text"
                      name="target"
                      select-label="Click to select"
                      deselect-label="Click to remove"
                      :placeholder="bannerItem.bannerType == 'brand' ? 'Select Brand Category' : 'Select Product Item'"
                      :allow-empty="true"
                      :preselect-first="false"
                      :class="{
                        'invalid': errors[0]
                      }"
                    ></multiselect>
                    <b-form-invalid-feedback v-bind="ariaMsg">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </div>
              </div>
              <div class="cold-md-12 mb-3">
                <image-upload v-model="bannerImage" :imageSrc="bannerItem.bannerPreviewImage" label="Banner Image" :isRequired="true" />
              </div>
              <div class="cold-md-12 mb-3">
                <div class="form-check form-switch">
                  <input class="form-check-input" v-model="bannerItem.bannerActiveNow" type="checkbox" id="flexSwitchCheckDefault">
                  <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                </div>
              </div>
            </div>    
            <div class="text-end mt-3">
              <b-button
                variant="light"
                class="w-sm"
                @click="leaveform('edit')"
                >Close
              </b-button
              >
              <b-button
                :disabled="!esuppliesBannerModule.access.update"
                variant="primary" 
                class="w-sm ms-2"
                type="submit"
                >Save
              </b-button>
            </div>
          </b-form>
        </ValidationObserver>
    </b-modal>
    <!-- end edit modal -->
  </div>
</template>

<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
    display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background:#f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092!important;
  border-color: #e73092!important;
  margin-bottom: 0!important;
  font-weight: 400!important;
}

.multiselect__tag-icon:after {
    color: #fff !important;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
  background-color: #e73092!important;
}


</style>